export const normalizePhoneForApi = (phone) => {
  if (!phone) return "";
  return String(phone).replace(/\D/g, "");
};
